// extracted by mini-css-extract-plugin
module.exports = {"link":"MenuLink__link--2dMes"};
    if(module.hot) {
      // 1605595234126
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  